import { Box, Card, CardHeader, Container, Heading, Text } from '@chakra-ui/react'
import React from 'react'
import { CardBody } from '@chakra-ui/card'
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'
import MainBox from '@/components/MainBox'
import Head from 'next/head'

export type TextLine = {
  text?: string
  title?: string
  section?: string
  space?: boolean
}

const content: TextLine[] = [
  {
    text: "La politique énoncée ci-après s'applique aux traitements de données personnelles effectués par la société à responsabilité limitée STARTAPP (désigné le « Responsable de Traitements » ou le « Responsable »).",
  },
  { space: true },
  {
    text: "Le Responsable est soucieux de garantir une utilisation intègre et un dispositif de sécurité et de confidentialité adéquat concernant les données susceptibles d'identifier les utilisateurs (ci-après, les « Données Personnelles »).",
  },
  {
    text: "La présente politique de confidentialité vous informe sur les Données Personnelles recueillies auprès de vous, sur la manière dont ces Données Personnelles peuvent être utilisées et communiquées, sur la manière dont vous pouvez contrôler l'utilisation et la divulgation de vos Données Personnelles et sur la manière dont vos Données Personnelles sont protégées.",
  },
  // {
  //   title: 'I - Dispositions générales',
  // },
  // {
  //   text: 'Les dispositions qui suivent concernent tous les traitements de Données Personnelles effectués par Le Responsable du Traitement, sauf mention contraire dans les dispositions spécifiques.',
  // },
  { section: '1. Identité du Responsable du traitement' },
  {
    text: 'Le Responsable du Traitement est la société STARTAPP dont le siège social est au 26 rue Loriot de Rouvray, Baie des citrons immatriculé au RCS de Nouméa sous le numéro 1 304 054, représentée par son gérant.',
  },
  {
    section: '2. Cadre juridique - conformité au RGPD',
  },
  {
    text: "Le Responsable du Traitement déclare qu'il effectue des traitements de données personnelles conformément à la loi applicable en Nouvelle-Calédonie, et précisément à la loi française n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés dans sa rédaction résultant de l'ordonnance n°2018-1125 du 12 décembre 2018 prise en application de l'article 32 de la loi n°2018-493 du 20 juin 2018 relative à la protection des personnes, laquelle prise en vertu du règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données (désigné « RGPD »).",
  },
  { section: '3. Par quels moyens sont collectées vos données ?' },
  {
    text: 'Dans le cadre de notre activité, nous sommes amenés à collecter vos Données Personnelles directement via le Site Internet https://www.freelances.nc',
  },
  { space: true },
  {
    text: 'En ce sens, https://www.freelances.nc (désigné comme « FREELANCES.NC » ou le « Site Internet ») collecte et traite les Données Personnelles suivantes :',
  },
  { space: true },
  { text: 'Pour les Freelances:' },
  { text: '- Nom, prénom, date de naissance' },
  { text: '- Email, téléphone' },
  { text: '- Statut' },
  { text: '- Métiers, domaines de compétences, compétences' },
  { space: true },
  { text: 'Pour les Entreprises:' },
  { text: '- Statut' },
  { text: '- Nom, prénom' },
  { text: '- Société' },
  { text: '- Téléphone, email' },
  { space: true },
  { text: 'Les données de connexions : adresse IP, navigateur ;' },
  {
    text: "Les données marketing des utilisateurs du Site internet ou de l'application, via les cookies (voir ci-après).",
  },
  { text: 'Vous êtes susceptibles de nous communiquer par différents moyens et notamment :' },
  { space: true },
  { text: 'Pendant vos navigations sur le site internet https://www.freelances.nc ;' },
  {
    text: 'En remplissant les divers formulaires, et notamment le formulaire de contact ou de réclamation ;',
  },
  { text: "Lors d'une souscription à un service ou à une newsletter ;" },
  { text: "Et de façon générale lorsqu'il établit tout contact avec FREELANCES.NC." },
  { space: true },
  {
    text: "Le Site Internet ne procède en ligne à aucune collecte de donnée dite « sensible » (c'est-à-dire notamment relative à la santé, l'origine raciale ou ethnique, à l'appartenance syndicale, à l'opinion politique, à l'appartenance religieuse).",
  },
  { section: '4. Dans quels buts sont collectées vos données ?' },
  {
    text: 'Les finalités du traitement auquel sont destinées les Données Personnelles sont les suivantes :',
  },
  { space: true },
  { text: 'La création et la gestion de votre compte ;' },
  { text: 'L’utilisation des services du site ;' },
  {
    text: 'Vous adresser des communications liées à vos actions sur la Marketplace (courriels transactionnels) ;',
  },
  {
    text: 'S’assurer que les missions proposées soient pertinentes (modération des leads, politique de lutte contre le spam);',
  },
  {
    text: 'Garantir la qualité des profils, lutter contre la fraude, vérifier les informations des profils ;',
  },
  {
    text: 'Effectuer un suivi personnalisé pour vous adresser que des communications pertinentes et adaptées à vos besoins directement en lien avec les services du site;',
  },
  {
    text: "Suivi et amélioration de la navigation sur le Site Internet ou l'application : les cookies peuvent contenir des informations personnelles comme notamment le comportement de navigation ;",
  },
  { text: "Satisfaction de nos obligations de vigilance à l'égard des utilisateurs ;" },
  {
    text: "Assurance de la sécurité physique, logique et informatique de nos systèmes d'information et de nos réseaux.",
  },
  { space: true },
  {
    section:
      '5. Sur quelles bases légales nous reposons-nous pour traiter vos Données Personnelles ?',
  },
  {
    text: 'Le Site Internet traite vos Données Personnelles avec votre consentement exprès. Dans ce cas, la fourniture des dites Données Personnelles est communiquée directement par vos soins, et à défaut, FREELANCES.NC ne sera pas en mesure de fournir le(s) service(s) demandé(s).',
  },
  { space: true },
  {
    text: 'Pour les besoins de la poursuite de nos intérêts légitimes et dans le respect de vos droits et libertés, FREELANCES.NC et les Professionnels traitent vos Données Personnelles, dans le cadre de mise en relation entre Freelances et Entreprises et notamment :',
  },
  { space: true },
  { text: 'Suivi de vos demandes ;' },
  { text: "Communication afin d'informer et de développer nos services ;" },
  {
    text: "Réalisation d'études statistiques concernant l'utilisation de notre Site Internet FREELANCES.NC ou et de leur mesure d'audience ;",
  },
  {
    text: "Analyse de vos Données Personnelles notamment pour personnaliser les services et informations que nous proposons en fonction de votre profil d'utilisation, et vous adresser des messages, communications personnalisées ou non, concernant nos services ;",
  },
  {
    text: "Garantie de la sécurité physique, logique et informatique de nos systèmes d'information et de nos réseaux.",
  },
  { space: true },
  {
    text: "Ces Données Personnelles sont collectées directement auprès vous ou indirectement, et nécessitent votre consentement exprès. Vous n'êtes pas tenu de fournir ces données et vous pouvez vous opposer à tout moment à leur traitement. Dans ce cas, FREELANCES.NC et les Professionnels ne seront pas en mesure de mettre en œuvre les finalités pour lesquelles elles sont recueillies.",
  },
  { space: true },
  {
    text: "Conformément aux réglementations en vigueur, vous avez un droit d'accès permanent, de modification, de rectification, d'opposition, de portabilité et de limitation du traitement s'agissant des informations vous concernant. Vos droits seront décrits plus en détails au sous-titre 8 « Comment exercez-vos droits ? » du présent titre.",
  },
  { space: true },
  { section: "6. Qui est susceptible d'accéder à vos Données Personnelles ?" },
  {
    text: "Vos données personnelles peuvent être communiquées, outre à notre personnel interne dûment habilité à les traiter, aux Professionnels dans le cadre de notre mission de mise en contact avec l'Utilisateur pour les seuls besoins de la réalisation de la ou des finalités pour lesquelles elles sont recueillies.",
  },
  { space: true },
  {
    text: "Nous demandons par ailleurs aux Professionnels de mettre en œuvre toutes les mesures techniques et organisationnelles nécessaires pour garantir, tout au long de leurs interventions, la sécurité et de la confidentialité de vos traitements de Données Personnelles, qu'ils opèrent pour notre compte, et de nous restituer ou de supprimer, l'ensemble des Données Personnelles qu'ils ont reçus à la fin de leur prestation.",
  },
  { space: true },
  {
    text: 'En aucun cas vos Données Personnelles ne seront révélées à aucune autre partie tierce sauf exceptions suivantes :',
  },
  { space: true },
  {
    text: 'Si la communication par FREELANCES.NC de certaines données personnelles est requise par les lois et règlements en vigueur, par une autorité gouvernementale ou judiciaire compétente, pour établir ou conserver une action en justice ou une défense, ou pour empêcher une fraude ou une activité illégale.',
  },
  {
    text: 'Pour protéger les droits, la propriété ou la sécurité de FREELANCES.NC, de nos fournisseurs, de nos clients ou du public, conformément à ce qui est requis ou autorisé par la loi.',
  },
  { space: true },
  { section: '7. Combien de temps sont conservées vos Données Personnelles ?' },
  {
    text: "De manière générale, nous veillons à ne pas conserver vos Données Personnelles au-delà du temps nécessaire à l'exécution des finalités pour lesquelles celles-ci ont été collectées. Ces durées de conservation sont définies en fonction des finalités de traitement mis en œuvre par le Responsable de Traitement et tiennent notamment compte des dispositions légales applicables imposant une durée de conservation précise pour certaines catégories de données, des éventuels délais de prescription qui y sont attachés, ainsi que des recommandations de la CNIL concernant certaines catégories de traitements de données et conformément à l'article 6-5° de la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, les données à caractère personnel.",
  },
  { space: true },
  { text: 'A ce titre :' },
  { space: true },
  {
    text: "Certaines de vos Données Personnelles, telles que vos données de consommation seront anonymisées et conservées sans délais d'échéance.",
  },
  {
    text: "En cas de procédure contentieuse, les Données Personnelles ainsi que toute information, documents et pièces contenant des Données Personnelles tendant à établir les faits susceptibles d'être reprochés ou concernant l'identification des mis en cause, des victimes, des témoins, peuvent être conservées pour la durée de la procédure. A l'issue de cette période, vos Données Personnelles seront supprimées ou irréversiblement anonymisées.",
  },
  { section: '8. Comment exercer vos droits ?' },
  { text: 'La personne dont les données personnelles sont collectées a le droit :' },
  { space: true },
  {
    text: "Le droit à l'information via la présente politique de conformité qui fournit toutes les informations sur l'utilisation des données et des droits des personnes.",
  },
  {
    text: "Le droit d'accès attribue à toute personne physique justifiant de son identité le droit d'interroger le responsable du traitement pour savoir s'il détient des informations sur elle, et le cas échéant d'en obtenir communication.",
  },
  {
    text: 'Le droit de rectification permet de demander à ce que ses données soient rectifiées, complétées ou mises à jour.',
  },
  {
    text: "Le droit à l'effacement (ou droit à l'oubli) octroie le droit d'obtenir du responsable du traitement l'effacement de données à caractère personnel la concernant.",
  },
  {
    text: "Le droit à la limitation permet d'obtenir du responsable du traitement la limitation du traitement et l'utilisation des données pendant un laps de temps défini.",
  },
  {
    text: "Le droit d'opposition octroie à toute personne la possibilité de s'opposer, pour des raisons tenant à sa situation particulière, à figurer dans un fichier. Il appartient au responsable du traitement de prouver qu'il dispose d'un motif légitime et impérieux à traiter ces données, prévalant sur les intérêts et les droits et libertés de la Personne Concernée, ou pour la constatation, l'exercice ou la défense de droits en justice.",
  },
  {
    text: "Le droit à la portabilité vous offre la possibilité de récupérer une partie de vos données dans un format lisible par une machine. Libre à vous de stocker ailleurs ces données portables ou les transmettre facilement d'un système à un autre, en vue d'une réutilisation à d'autres fins.",
  },
  {
    text: "Vous pouvez exercer l'ensemble de ces droits en vous adressant au Responsable du Traitement de données du Site Internet par l'un des moyens suivants :",
  },
  { space: true },
  { text: 'par email envoyé à contact@startapp.nc' },
  {
    text: "par courrier signé accompagné de la copie de votre titre d'identité à l'adresse suivante :",
  },
  { text: 'STARTAPP' },
  { text: '26 RUE LORIOT DE ROUVRAY' },
  { text: '98800 Nouméa, Nouvelle-Calédonie' },
  {
    text: "Le Responsable s'engage à traiter votre demande un délai d'un (1) mois à réception de la demande, éventuellement prolongé d'un mois sur justification.",
  },
  { space: true },
  {
    text: "Vous disposez également de la possibilité d'introduire une réclamation auprès de la Commission Nationale Informatique et Libertés (CNIL) :",
  },
  { space: true },
  { text: 'Sur le site internet de la CNIL :' },
  { text: 'dans certains cas déterminés, par le téléservice de plainte en ligne ;' },
  { text: 'dans les autres cas non prévus par le téléservice, par le service "Besoin d\'aide".' },
  {
    text: 'Par courrier postal en écrivant à : CNIL - 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX',
  },
  {
    text: "Vous pouvez vous opposer au traitement de vos Données Personnelles à des fins de prospection, dans les conditions prévues par la réglementation, ou retirez votre consentement, à tout moment, par l'un des moyens suivants :",
  },
  { space: true },
  { text: 'Cliquer sur le lien de désinscription situé en bas de chaque communication,' },
  { text: 'En vous adressant aux adresses de contact dans les conditions susmentionnées.' },
  { section: '9. Modifications' },
  {
    text: 'Nous nous réservons le droit, à notre seule discrétion, de modifier à tout moment la présente « politique de confidentialité ».',
  },
  { space: true },
  {
    text: "L'Utilisateur est invité à consulter régulièrement la présente politique afin de prendre connaissance de toute mise à jour ou modification.",
  },
  { space: true },
  {
    text: "Ces modifications entreront en vigueur à compter de la publication du nouveau document. Dans la mesure du possible, vous en serez informé auparavant par tout moyen (ex., email, notification dans l'Application, etc.). Lorsque cela s'avèrera nécessaire, nous chercherons à obtenir votre consentement.",
  },
  { space: true },
  // { title: 'II - Dispositions spécifiques' },
  // {
  //   text: 'Les dispositions qui suivent sont spécifiques à chaque type de traitement de Données Personnelles.',
  // },
  // { space: true },
  // { section: '1. Utilisation normale du Site' },
  // { space: true },
  // { text: 'Vos données personnelles : nom, prénom, coordonnées emails et téléphoniques ;' },
  // {
  //   text: "Votre comportement sur notre Site Internet est tracé à l'aide de cookies (voir « politique des cookies ») notamment les informations sur les biens immobiliers consultés et les liens suivis ;",
  // },
  // {
  //   text: "L'ouverture et le clic dans les courriels que nous vous adressons, qu'ils soient liés à la gestion de votre contrat, informationnels ou à portée commerciale ;",
  // },
  // {
  //   text: 'Les informations relatives à nos communications avec vous (par courriel, le Site internet).',
  // },
  // {
  //   text: 'Moyens de collecte : Nous recueillons les données liées aux différentes interactions que nous pouvons avoir avec vous sur notre Site Internet, notamment par le biais des formulaires de contact.',
  // },
  // { space: true },
  // { text: 'Finalités : Ce traitement est utilisé à des fins de :' },
  // { space: true },
  // {
  //   text: "analyses statistiques et d'amélioration de la qualité de nos services consistant notamment dans l'optimisation du contenu des pages du Site et l'optimisation de la navigation ;",
  // },
  // {
  //   text: 'améliorer notre communication et à vous adresser des contenus pertinents concernant le Site et les biens que vous consultez ;',
  // },
  // {
  //   text: "vous permettre de prendre contact avec l'Entreprise en lien avec le bien sur lequel le formulaire est basé ;",
  // },
  // { text: 'répondre à vos demandes.' },
  // {
  //   text: "Fondement légal : Le traitement repose sur le consentement exprès et préalable de la personne et est nécessaire aux fins des intérêts légitimes que nous poursuivons. Le Responsable des Traitements peut recourir aux services de partenaires afin d'optimiser le Site Internet www.FREELANCES.nc. Ces partenaires ont un accès limité aux données des utilisateurs. Cet accès ne leur permet que d'effectuer des tâches au nom du Responsable envers qui ils sont tenus de ne pas divulguer ces données ni de les utiliser à d'autres fins que celles autorisées par celui-ci.",
  // },
  // { space: true },
  { section: '10. Politique des cookies' },
  {
    text: 'Lors de la consultation de notre Site, des cookies sont déposés sur votre terminal de connexion (ordinateur, tablette, smartphone) afin de mesurer la fréquentation du site et améliorer votre expérience utilisateur.',
  },
  { space: true },
  { section: "Qu'est-ce qu'un « cookie » ?" },
  {
    text: 'Un "cookie" est une suite d\'informations, généralement de petite taille et identifié par un nom, qui peut être transmis à votre navigateur par le Site. Ils sont gérés par votre navigateur et permettent de conserver des données utilisateur pendant une certaine durée. Les cookies ont de multiples usages : ils peuvent servir à mémoriser votre identifiant client auprès du Site https://www.freelances.nc, le contenu courant de votre panier d\'achat, un identifiant permettant de tracer votre navigation pour des finalités statistiques ou publicitaires, etc.',
  },
  { space: true },
  { text: 'Les trois types de cookies émis à partir du Site FREELANCES.NC :' },
  {
    text: 'Lors de votre première visite sur le Site, un bandeau vous informe de la présence des cookies et vous invite à indiquer votre choix. Ils ne sont stockés dans votre ordinateur que si vous les acceptez.',
  },
  { space: true },
  { text: '- Cookies internes nécessaires au bon fonctionnement du Site' },
  {
    text: "Ils permettent au Site de fonctionner de manière optimale. Vous pouvez vous y opposer et les supprimer en utilisant les paramètres de votre navigateur, cependant votre expérience utilisateur risque d'être dégradée.",
  },
  { space: true },
  { text: "- Cookies de mesures d'audience du Site" },
  {
    text: "Ils permettent d'obtenir des informations sur la navigation des visiteurs et notamment de comprendre comment les utilisateurs arrivent sur un site et de reconstituer leur parcours. Nous utilisons l'outil de mesure d'audience Google Analytics, géré par un outil de Tag Management : Google Tag Manager.",
  },
  { space: true },
  {
    text: "Nous collectons votre adresse IP, afin de déterminer la ville depuis laquelle vous vous connectez. Celle-ci est immédiatement anonymisée pour les mesures d'audience. Nous ne pouvons donc en aucun cas remonter par ce biais à une personne physique.",
  },
  { space: true },
  { text: "- Cookies tiers destinés à améliorer l'interactivité du Site" },
  {
    text: "Notre Site comporte un bouton de partage Facebook et certaines pages du Site peuvent intégrer du contenu vidéo hébergé par la plateforme YouTube. En visitant une page contenant une vidéo, ou un lien de partage du réseau social, en cliquant pour voir la vidéo ou sur l'encart Facebook, les cookies peuvent être rappelés.",
  },
  { space: true },
  {
    text: 'Lors de votre première visite sur le Site, un bandeau vous informe de la présence de ces cookies et vous invite à indiquer votre choix. Ils ne sont déposés que si vous les acceptez ou que vous poursuivez votre navigation sur le Site en visitant une seconde page du Site. Vous pouvez à tout moment vous informer et paramétrer vos cookies pour les accepter ou les refuser en vous rendant sur la page du Site. Vous pourrez indiquer votre préférence soit globalement pour le Site, soit service par service.',
  },
  { space: true },
  { text: "Moyens d'opposition au dépôt des cookies via votre navigateur :" },
  {
    text: "Vous pouvez choisir la suppression de l'ensemble des cookies déposés sur votre terminal à tout moment. Veuillez noter que la suppression des cookies peut dégrader votre expérience utilisateur sur notre Site. Nous vous conseillons d'utiliser la page du Site si vous souhaitez désactiver les cookies non indispensables au fonctionnement du Site.",
  },
  { space: true },
  {
    text: 'Voici le détail des paramétrages à effectuer pour bloquer le dépôt de cookies depuis votre navigateur :',
  },
  { space: true },
  { text: 'Firefox' },
  { text: 'Chrome' },
  { text: 'Safari' },
  { text: 'Opera' },
  { text: 'Edge' },
  { space: true },
  { section: '11. Nos recommandations' },
  {
    text: 'Le Responsable de traitement ne peut pas garantir la sécurité de vos Données Personnelles sans votre collaboration. Nous vous recommandons de suivre les recommandations suivantes pour protéger au mieux vos Données Personnelles :',
  },
  { space: true },
  {
    text: 'Utilisez des mots de passe complexes et différents pour chacun de vos comptes internet.',
  },
  {
    text: 'Ne partagez jamais vos mots de passe, vos identifiant, et informations personnelles.',
  },
  {
    text: "Déconnectez-vous de votre compte lorsque vous utilisez un ordinateur que vous partagez avec d'autres personnes.",
  },
  { text: 'Modifiez votre mot de passe au moins une fois par an.' },
  { text: 'Installez et mettez à jour régulièrement un antivirus reconnu sur votre ordinateur.' },
  { text: 'Mise en ligne & date de mise en application : 13/04/23' },
]

function ProtectionDesDonneesRgpd() {
  return (
    <MainBox>
      <Head>
        <title>Protection des données</title>
      </Head>
      <Container maxW={'container.xl'} pt={{ base: 2, md: '10' }}>
        <Card variant="outline" size={{ base: 'sm', md: 'lg' }}>
          <CardHeader>
            <Heading fontSize={{ base: 'md', md: '3xl' }}>Politiques de confidentialité</Heading>
          </CardHeader>
          <CardBody>{formatTextData(content)}</CardBody>
        </Card>
      </Container>
    </MainBox>
  )
}

export const formatTextData = (lines: TextLine[]): (ReactJSXElement | null)[] => {
  return lines.map((item, index) => {
    if (item.text) {
      return <Content key={index} text={item.text} />
    } else if (item.title) {
      return <Title key={index} title={item.title} />
    } else if (item.section) {
      return <Section key={index} title={item.section} />
    } else if (item.space) {
      return <Box key={index} h={'16px'}></Box>
    }
    return null
  })
}

export const Title = ({ title }: { title: string }) => {
  return (
    <Text fontWeight={'bold'} fontSize={{ base: '14px', md: '18px' }} mt={6} mb={1}>
      {title}
    </Text>
  )
}

export const Section = ({ title }: { title: string }) => {
  return (
    <Text fontWeight={'semibold'} fontSize={{ base: '10px', md: '16px' }} pt={4}>
      {title}
    </Text>
  )
}

export const Content = ({ text }: { text: string }) => {
  return <Text fontSize={{ base: '10px', md: '14px' }}>{text}</Text>
}

export default ProtectionDesDonneesRgpd
